import ContentSection from './ContentSection';
import ModalText from './ModalText';
import ModalTitle from './ModalTitle';
import ModalMain from './Modal';
import ButtonSection from './ButtonSection';
import ModalButton from './ModalButton';
import ModalCloseButton from './ModalCloseButton';

export const Modal = Object.assign(ModalMain, {
  Text: ModalText,
  Title: ModalTitle,
  ContentSection: ContentSection,
  ButtonSection: ButtonSection,
  Button: ModalButton,
  CloseButton: ModalCloseButton
});
